import React from "react";
import { Grid } from 'semantic-ui-react';
import RepeatableContainer from "../../commonComponents/form/repeatableFormContainer";
import EntrySummaryRepeatable from "./EntrySummaryRepeatable";

import {InputField, Accordion, AccordionItem} from 'KN-EU-Broker-Dashboard-UI'


const EntrySummaryTab = ({onChange}) => {
    return ( 
        <Grid className="responsiveGridCss1 tab-container" data-reducer="updateEntrySummaryTab" >
            <RepeatableContainer
                reducerName="entrySummary"
                keyName="entrySummaryTab"
                onChange={onChange}
                renderForm={(params) => <EntrySummaryRepeatable {...params} />}
            />
        </Grid>
    );
}
 
export default EntrySummaryTab;